export const MAX_LABEL_TITLE_LENGTH = 12;
